// extracted by mini-css-extract-plugin
export default {"text":"Description_text__eEKc7"};